<template>
  <component :is="layout">
    <router-view/>
    <notifications/>
  </component>
</template>

<script>
import EmptyLayout from '@/layouts/EmptyLayout';
import MainLayout from '@/layouts/MainLayout';
import axios from "axios";

export default {
  name: 'main-app',
  data: function(){
    return{
      connection: null,
    }
  },
  computed: {
    layout: function(){
      return (this.$route.meta.layout || 'main') + '-layout'
    },
    isLoggedIn: function() {
      return this.$store.getters.isLoggedIn;
    },
  },
  mounted: function () {
    this.$nextTick(function () {
      window.setInterval(() => {
        this.setCountMessageStore();
      },5000);
    });
  },
  methods: {
    syncCount: function(count){
      if(count > 0 && count > this.$store.state.countMessage){
        this.$store.state.countMessage = count;
        this.$toast.info('У вас новое сообщение');
      }else if(count === 0){
        this.$store.state.countMessage = 0;
      }
    },
    setCountMessageStore: function(){
      axios.post('getAllCountMessageFromClient').then(response => {
        var status = response.data.status;
        if(status){
          this.syncCount(response.data.count);
        }
      });
    },
    logout: function() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    }
  },
  components: {
    EmptyLayout, MainLayout
  }
};
</script>

<style lang="scss">
@import "~bootstrap/scss/bootstrap.scss";
@import "assets/css/style.css";
</style>
